import { Box } from "@mui/material";
import {
  CloseIconWrapper,
  ModalTitle,
  StyledContainedButton,
  StyledDialog,
} from "./style";
import { CloseIcon, LogoSmall } from "../../assets/Icons";
import { useDispatch, useSelector } from "react-redux";
import { openUpgradePlanModalSelector } from "../../store/metadata/selector";
import { MetaDataReducerAction } from "../../store/metadata/slice";
import { useNavigate } from "react-router-dom";
import routeConstant from "../../utils/routeConstant";

const UpgradePlanModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const open = useSelector(openUpgradePlanModalSelector);

  const handleClose = () => {
    dispatch(MetaDataReducerAction.setOpenUpgradePlanModal(false));
  };

  return (
    <StyledDialog onClose={handleClose} open={open} maxWidth="sm" fullWidth>
      <CloseIconWrapper aria-label="close" onClick={handleClose}>
        <CloseIcon />
      </CloseIconWrapper>

      <Box
        sx={{
          margin: "57px 0 30px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            height: "68px",
            width: "68px",
            backgroundColor: "#151616",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8.89px",
            marginBottom: "26px",
          }}
        >
          <LogoSmall />
        </Box>
        <ModalTitle>Upgrade your plan to access this feature</ModalTitle>
        <StyledContainedButton
          variant="contained"
          size="small"
          sx={{
            marginTop: "46px",
          }}
          onClick={() => {
            handleClose();
            navigate(`${routeConstant.subscription}`);
          }} // assuming you have a pricing/upgrade page route
        >
          Upgrade Plan
        </StyledContainedButton>
      </Box>
    </StyledDialog>
  );
};

export default UpgradePlanModal;
